import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const DropZoneRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const DropZoneLabel = styled.label`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 32px 24px;
  min-height: 160px;
  text-align: center;
  cursor: pointer;
  border: 2px dashed
    ${(props) => props.theme.atlas.semantic.color.outline.default};
  border-radius: 4px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.subtle};

  &:hover {
    border-color: ${(props) => props.theme.atlas.semantic.color.type.disabled};
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.variant};
  }

  & input {
    display: none;
  }
`;

export const UploadIconWrapper = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  font-size: 32px;
  line-height: 1;
`;

export const DropZoneText = styled.p`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  user-select: none;
`;

export const BrowseLink = styled.span`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  text-decoration: underline;
  cursor: pointer;
`;

export const FileSizeLimitText = styled.p`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
  user-select: none;
`;

export const InfoFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  margin-top: 16px;
  width: 100%;
`;

export const InfoIconWrapper = styled.div`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.outline.default};
  color: ${(props) =>
    props.theme.atlas.semantic.color.action.primary.onPrimary};
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.caption)}
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoText = styled.p`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  line-height: 20px;
`;

export const HelpArticleLink = styled.a`
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.atlas.semantic.color.action.primary.hover};
  }
`;
